import React, {useContext} from 'react';
import {Toolbar} from 'react-onsenui';
import {Link} from "react-router-dom";
import {AppStoreContext} from "components/Mall/AppStore/AppStore";
import logo from 'containers/Main/mediumLogo.png'

// eslint-disable-next-line import/no-anonymous-default-export
export default () => {
    const AppStore = useContext(AppStoreContext);
    return <Toolbar style={{boxShadow: "0 5px 6px -6px #888888", position: "unset"}}>
        <div className='left' style={{display: "none"}}/>
        <div className='center' style={{display: "none"}}/>
        <div className='right' style={{display: "none"}}/>
        <div className="exceed_toolbar">
            <img id="logo" alt="Exceed.ai" src={logo}/>

            <div className="details">
                <Link to="/switchProject"
                      className={"exceed_link"}>{AppStore.getSelectedBot.name}</Link>

                {
                    AppStore.selectedBot.imageURL ?
                        <img id="icon" alt="Exceed.ai" src={AppStore.getSelectedBot.imageURL}/> :
                        <img className="list-item__thumbnail" alt="Exceed.ai" style={{paddingRight: "3px"}}
                             src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAIAAAADnC86AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAB3RJTUUH3wwJCB8v/9zErgAAABl0RVh0Q29tbWVudABDcmVhdGVkIHdpdGggR0lNUFeBDhcAAAAvSURBVFjD7c0BDQAACAMgtX+KJzWGm4MCdJK6MHVELBaLxWKxWCwWi8VisVj8MV7qBgI2A8rYpgAAAABJRU5ErkJggg=="/>
                }
            </div>
        </div>
    </Toolbar>
}